// extracted by mini-css-extract-plugin
export default {"navTitle":"o07N4TYl"};